import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { useTranslation } from 'react-i18next';

/*
 * This Component is strictly used inside Resource Inner templates.
 * A significant amount of French translation pages are AI generated and we wish to give a disclaimer about that (~75% accuracy)
 * Content also has the option in an ACF to manually disable this on French pages (It is shown by default)
 */

export interface IAIFrenchDisclaimerProps extends IBaseElementProps {
	disclaimer?: string;
}
const AIFrenchDisclaimer: React.FC<IAIFrenchDisclaimerProps> = ({
	id,
	className,
	classNames = [],
	disclaimer,
}) => {
	const { t } = useTranslation();
	return (
		<div
			id={id}
			className={className || cn('ai-french-disclaimer', ...classNames)}
		>
			<div className="ai-french-disclaimer__container border-top border-1 calian-container calian-container-post py-5 py-md-6 px-0">
				<p className="mb-0 mw-753px mx-auto d-block text-center fs-7 opacity-75">
					{disclaimer
						? disclaimer
						: t(
								'This page has been translated using AI technology. Though we aim for accuracy, automated translations may not fully capture the nuances and context of the original content.',
						  )}
				</p>
			</div>
		</div>
	);
};

export default AIFrenchDisclaimer;
